import { render, staticRenderFns } from "./ClientProjectsRegionSelect.vue?vue&type=template&id=3060a3c0&"
import script from "./ClientProjectsRegionSelect.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsRegionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports